// Navigation configuration for the sidebar

export const navigationConfig = [
  {
    id: 'home',
    label: 'Home',
    destination: 'home',
    future: false
  },
  {
    id: 'engineering',
    label: 'Engineering',
    destination: 'documentation-dashboard',
    future: false,
    children: [
      {
        id: 'drawings',
        label: 'Drawings',
        destination: 'drawings',
        future: false,
        children: [
          { id: 'drawing-log', label: 'Drawing Log', destination: 'drawing-log', future: false }
        ]
      },
      {
        id: 'assets',
        label: 'Assets',
        destination: 'equipment-dashboard',
        future: false,
        children: [
          { id: 'tags', label: 'Tags', destination: 'tags', future: false },
          { id: 'panels', label: 'Panels', destination: 'panels', future: false }
        ]
      },
      {
        id: 'networking',
        label: 'Networking',
        destination: 'networking-dashboard',
        future: false,
        children: [
          { id: 'ip-address-sln', label: 'Site Level', destination: 'ip-address-sln', future: false },
          { id: 'ip-address-dln', label: 'Device Level', destination: 'ip-address-dln', future: false },
          { id: 'networks-enet', label: 'Ethernet Connections', destination: 'networks-enet', future: false },
          { id: 'networks-serial', label: 'Serial Connections', destination: 'networks-serial', future: false },
          { id: 'plc-msg-map', label: 'Messaging', destination: 'plc-msg-map', future: false }
        ]
      },
      {
        id: 'power-distribution',
        label: 'Power Distribution',
        destination: 'power-distribution-dashboard',
        future: false,
        children: [
          { id: 'pwr-dist', label: 'Power Distribution', destination: 'pwr-dist', future: false }
        ]
      },
      {
        id: 'sequences',
        label: 'Sequences of Operation',
        destination: 'sequences-dashboard',
        future: false,
        children: [
          { id: 'soo-index', label: 'Index', destination: 'soo-index', future: false },
          { id: 'soo-log', label: 'Log', destination: 'soo-log', future: false },
          { id: 'soo-equipment', label: 'Equipment', destination: 'soo-equipment', future: false }
        ]
      },
      {
        id: 'supporting-docs',
        label: 'Supporting Documentation',
        destination: 'supportingdocs-dashboard',
        future: false,
        children: [
          {
            id: 'setup-project',
            label: 'General',
            destination: 'supportingdocs-general',
            future: false,
            children: [
              { id: 'buildings', label: 'Building', destination: 'buildings', future: false },
              { id: 'source', label: 'Source', destination: 'source', future: false },
              { id: 'discipline', label: 'Discipline', destination: 'discipline', future: false },
              { id: 'system-code', label: 'System Code', destination: 'system-code', future: false }
            ]
          },
          {
            id: 'setup-panels',
            label: 'Panels',
            destination: 'supportingdocs-panels',
            future: false,
            children: [
              { id: 'card-type', label: 'Card Type', destination: 'card-type', future: false },
              { id: 'panel-type', label: 'Panel Type', destination: 'panel-type', future: false },
              { id: 'panel-terminal', label: 'Panel Terminal', destination: 'panel-terminal', future: false },
              { id: 'transfer-party-panels', label: 'Transfer Party', destination: 'transfer-party', future: false }
            ]
          },
          {
            id: 'setup-tags',
            label: 'Tags',
            destination: 'supportingdocs-tags',
            future: false,
            children: [
              { id: 'isa-type', label: 'ISA Type', destination: 'isa-type', future: false },
              { id: 'eng-units', label: 'Engineering Units', destination: 'eng-units', future: false },
              { id: 'wire-type', label: 'Wire Type', destination: 'wire-type', future: false },
              { id: 'valve-size', label: 'Valve Size', destination: 'valve-size', future: false },
              { id: 'transfer-party', label: 'Transfer Party', destination: 'transfer-party', future: false }
            ]
          },
          {
            id: 'setup-index',
            label: 'Index',
            destination: 'supportingdocs-index',
            future: false,
            children: [
              { id: 'index-sheet', label: 'Index Sheet', destination: 'index-sheet', future: false },
              { id: 'manufacturer', label: 'Manufacturer', destination: 'manufacturer', future: false }
            ]
          },
          {
            id: 'setup-network',
            label: 'Network',
            destination: 'supportingdocs-network',
            future: false,
            children: [
              { id: 'subnet', label: 'Subnet', destination: 'subnet', future: false }
            ]
          },
          {
            id: 'setup-commissioning',
            label: 'Commissioning',
            destination: 'supportingdocs-commissioning',
            future: false,
            children: [
              { id: 'commissioning-key', label: 'Commissioning Key', destination: 'commissioning-key', future: false }
            ]
          },
        ]
      }
    ]
  },
  {
    id: 'data-entry',
    label: 'Data Entry',
    destination: 'data-entry-dashboard',
    future: false,
    children: [
      { id: 'estimating', label: 'Estimating', destination: 'estimating', future: false },
      { id: 'integration', label: 'Integration', destination: 'integration', future: false },
      { id: 'submittals', label: 'Submittals', destination: 'submittals', future: false },
      { id: 'sub-contractors', label: 'Sub Contractors', destination: 'sub-contractors', future: false },
      { id: 'purchasing', label: 'Purchasing', destination: 'purchasing', future: false },
      { id: 'qaqc', label: 'QA/QC', destination: 'qaqc', future: false },
      { id: 'material-transfer', label: 'Material Transfer', destination: 'material-transfer', future: false },
      { id: 'commissioning', label: 'Commissioning', destination: 'commissioning', future: false }
    ]
  },
  {
    id: 'reports',
    label: 'Reports',
    destination: 'reports',
    future: false,
    children: [
      {
        id: 'reports-general',
        label: 'General',
        headerOnly: true,
        future: false,
        children: [
          { id: 'io-assignments', label: 'I/O Assignments', destination: 'reports/slugRptStd-Gen-IO_Assignments', future: false },
          { id: 'drawing-log-report', label: 'Drawing Log', destination: 'reports/slugRptStd-Gen-Drawing_Log', future: false },
          { id: 'panel-report', label: 'Panel Report', destination: 'reports/slugRptStd-Gen-Panel_Report', future: false }
        ]
      },
      {
        id: 'reports-submittals',
        label: 'Submittals',
        headerOnly: true,
        future: false,
        children: [
          { id: 'index-panels', label: 'Index Report - Panels', destination: 'reports/slugRptStd-Sub-Index_Report_Panels', future: false },
          { id: 'index-tags', label: 'Index Report - Tags', destination: 'reports/slugRptStd-Sub-Index_Report_Tags', future: false }
        ]
      },
      {
        id: 'reports-networking',
        label: 'Networking',
        headerOnly: true,
        future: false,
        children: [
          { id: 'ip-addresses-dln', label: 'IP Addresses - Device Level', destination: 'reports/slugRptStd-Net-IP_Addresses_Device_Level', future: false },
          { id: 'ip-addresses-sln', label: 'IP Addresses - Site Level', destination: 'reports/slugRptStd-Net-IP_Addresses_Site_Level', future: false },
          { id: 'network-connection-report', label: 'Network Connection Report', destination: 'reports/slugRptStd-Net-Network_Connections', future: false }
        ]
      },
      {
        id: 'reports-commissioning',
        label: 'Commissioning',
        headerOnly: true,
        future: false,
        children: [
          { id: 'oat-report', label: 'OAT Report', destination: 'reports/slugRptStd-Cx-OAT_Report', future: false },
          { id: 'qaqc-report', label: 'QAQC Report', destination: 'reports/slugRptStd-Cx-Panel_QAQC_Report', future: false },
          { id: 'commissioning-status-report', label: 'Commissioning Status Report', destination: 'reports/slugRptStd-Cx-Commissioning_Status', future: false }
        ]
      }
    ]
  },
  {
    id: 'project-management',
    label: 'Project Management',
    destination: 'project-management',
    future: false,
    children: [
      {
        id: 'transmittals',
        label: 'Transmittals',
        destination: 'transmittals',
        future: false,
        children: [
          { id: 'material-transfer-log', label: 'Material Transfer Log', destination: 'material-transfer-log', future: true },
          { id: 'rfi-log', label: 'RFI Log', destination: 'rfi-log', future: false },
          { id: 'submittal-log', label: 'Submittal Log', destination: 'submittal-log', future: true }
        ]
      },
      { id: 'procurement-log', label: 'Procurement Log', destination: 'procurement-log', future: true },
      { id: 'cost-management', label: 'Cost Management', destination: 'cost-management', future: true },
      { id: 'change-management-log', label: 'Change Management Log', destination: 'change-management-log', future: true },
      {
        id: 'finance',
        label: 'Finance',
        headerOnly: true,
        children: [
          { id: 'estimate', label: 'Estimate', destination: 'estimate', future: true },
          { id: 'po-lines', label: 'PO Lines', destination: 'po-lines', future: true }
        ]
      }
    ]
  },
  {
    id: 'utilities',
    label: 'Utilities',
    destination: 'utilities',
    future: false,
    children: [
      { id: 'import-template', label: 'Bulk Import', destination: 'import-template', future: false },
      { id: 'power-query', label: 'Power Query', destination: 'power-query', future: false }
    ]
  },
  {
    id: 'integration-dashboard',
    label: 'Integration',
    destination: 'integration-dashboard',
    future: false,
    children: [
      { id: 'io-buffer-generation', label: 'IO Buffer Generation', destination: 'io-buffer-generation', future: false },
      { id: 'udt-comment-generator', label: 'UDT Comment Generation', destination: 'udt-comment-generator', future: false },
      { id: 'scada-tag-generation', label: 'SCADA Tag Generation', destination: 'scada-tag-generation', future: false },
      { id: 'simulation-tag-generation', label: 'Simulation Tag Generation', destination: 'simulation-tag-generation', future: false },
      {
        id: 'integration-configuration',
        label: 'Configuration',
        destination: 'integration-configuration',
        future: false,
        children: [
          { id: 'plc-platforms', label: 'PLC Platforms', destination: 'plc-platforms', future: false },
          { id: 'plc-tag-xref', label: 'Tag XRef', destination: 'plc-tag-xref', future: false }
        ]
      }
    ]
  },
  {
    id: 'administration',
    label: 'Administration',
    destination: 'administration-dashboard',
    future: false,
    adminOnly: true,
    children: [
      { id: 'admin-app-users', label: 'Users', destination: 'admin/app-users', future: true },
      {
        id: 'admin-database',
        label: 'Database',
        headerOnly: true,
        children: [
          { id: 'database-sync', label: 'Data Synchronization', destination: 'database-sync', future: false },
          { id: 'view-synchronizer', label: 'View Synchronization', destination: 'view-synchronizer', future: false },
          { id: 'schema-synchronizer', label: 'Schema Synchronization', destination: 'schema-synchronizer', future: false }
        ]
      },
      {
        id: 'admin-security',
        label: 'Security',
        destination: 'admin/dashboard',
        children: [
          { id: 'security-overview', label: 'Security Overview', destination: 'admin/security', future: false },
          { id: 'admin-users', label: 'Users', destination: 'admin/users', future: false },
          { id: 'admin-roles', label: 'Permission Defaults', destination: 'admin/roles', future: false },
          { id: 'admin-permissions', label: 'Permissions List', destination: 'admin/permissions', future: false },
          { id: 'admin-databases', label: 'Databases', destination: 'admin/databases', future: false },
          { id: 'admin-organizations', label: 'Organizations', destination: 'admin/organizations', future: false }
        ]
      },
      {
        id: 'admin-system',
        label: 'System',
        destination: 'admin/system-health',
        children: [
          { id: 'create-instance', label: 'Create Instance', destination: 'create-instance', future: true },
          { id: 'destroy-instance', label: 'Destroy Instance', destination: 'destroy-instance', future: true }
        ]
      },
    ]
  },
  {
    id: 'development',
    label: 'Development',
    destination: 'development-dashboard',
    future: false,
    adminOnly: true,
    children: [
      { id: 'dev-plan', label: 'Plan', destination: 'dev-plan', future: false },
      { id: 'task-log', label: 'Tasks', destination: 'task-log', future: false },
      { id: 'rev-log', label: 'Revisions', destination: 'rev-log', future: false },
      {
        id: 'dev-configuration',
        label: 'Configuration',
        headerOnly: true,
        children: [
          { id: 'display-settings', label: 'Display Settings', destination: 'display-settings', future: false },
          { id: 'field-manager', label: 'Field Manager', destination: 'field-manager', future: false },
          { id: 'lookup-values', label: 'Lookup Values', destination: 'lookup-values', future: false }
        ]
      },
      {
        id: 'composers',
        label: 'Composers',
        headerOnly: true,
        children: [
          { id: 'standard-view-config', label: 'Standard View', destination: 'standard-view-config', future: false },
          { id: 'data-entry-view-config', label: 'Data Entry View', destination: 'data-entry-view-config', future: false }
        ]
      },
      {
        id: 'references',
        label: 'References',
        headerOnly: true,
        children: [
          { id: 'claude-notes', label: 'PMD Claude Notes', destination: 'claude-notes', future: false },
          { id: 'icon-browser', label: 'Icon Browser', destination: 'icon-browser', future: false },
          { id: 'style-guide', label: 'Style Guide', destination: 'style-guide', future: false }
        ]
      }
    ]
  }
];

// Helper function to get page display name for UnderConstruction component
export const getPageDisplayName = (destination) => {
  const pageNames = {
    'documentation-dashboard': 'Engineering Dashboard',
    'drawing-log': 'Drawing Log',
    'networking-dashboard': 'Networking Dashboard',
    'ip-address-sln': 'IP Address - Site Level',
    'ip-address-dln': 'IP Address - Device Level',
    'networks-enet': 'Ethernet Connections',
    'networks-serial': 'Serial Connections',
    'plc-msg-map': 'PLC Messaging Map',
    'power-distribution-dashboard': 'Power Distribution Dashboard',
    'pwr-dist': 'Power Distribution',
    'sequences-dashboard': 'Sequences of Operation Dashboard',
    'soo-index': 'SOO Index',
    'soo-log': 'SOO Log',
    'soo-equipment': 'SOO Equipment',
    'equipment-dashboard': 'Assets Dashboard',
    'tags': 'Tags',
    'panels': 'Panels',
    'supportingdocs-dashboard': 'Supporting Documentation',
    'supportingdocs-general': 'General',
    'supportingdocs-panels': 'Panels',
    'supportingdocs-tags': 'Tags',
    'supportingdocs-index': 'Index',
    'supportingdocs-network': 'Network',
    'supportingdocs-commissioning': 'Commissioning',
    'data-entry-dashboard': 'Data Entry Dashboard',
    'estimating': 'Estimating',
    'integration-dashboard': 'Integration',
    'integration': 'Integration',
    'submittals': 'Submittals',
    'sub-contractors': 'Sub Contractors',
    'purchasing': 'Purchasing',
    'qaqc': 'QA/QC',
    'material-transfer': 'Material Transfer',
    'commissioning': 'Commissioning',
    'card-type': 'Card Type',
    'commissioning-key': 'Commissioning Key',
    'discipline': 'Discipline',
    'eng-units': 'Engineering Units',
    'index-sheet': 'Index Sheet',
    'isa-type': 'ISA Type',
    'manufacturer': 'Manufacturer',
    'panel-io-list': 'Panel IO List',
    'panel-terminal': 'Panel Terminal',
    'panel-type': 'Panel Type',
    'estimate': 'Estimate',
    'po-lines': 'PO Lines',
    'source': 'Source',
    'subnet': 'Subnet',
    'system-code': 'System Code',
    'transfer-party': 'Transfer Party',
    'valve-size': 'Valve Size',
    'wire-type': 'Wire Type',
    'reports': 'Reports',
    'reports/slugRptStd-Gen-IO_Assignments': 'I/O Assignments',
    'reports/slugRptStd-Gen-Drawing_Log': 'Drawing Log',
    'reports/slugRptStd-Net-IP_Addresses_Device_Level': 'IP Addresses - Device Level',
    'reports/slugRptStd-Net-IP_Addresses_Site_Level': 'IP Addresses - Site Level',
    'reports/slugRptStd-Net-Network_Connections': 'Network Connection Report',
    'reports/slugRptStd-Gen-Panel_Report': 'Panel Report',
    'reports/slugRptStd-Cx-OAT_Report': 'OAT Report',
    'reports/slugRptStd-Cx-Panel_QAQC_Report': 'QAQC Report',
    'reports/slugRptStd-Sub-Index_Report_Panels': 'Index Report - Panels',
    'reports/slugRptStd-Sub-Index_Report_Tags': 'Index Report - Tags',
    'reports/slugRptStd-Cx-Commissioning_Status': 'Commissioning Status Report',
    'project-management': 'Project Management',
    'transmittals': 'Transmittals',
    'material-transfer-log': 'Material Transfer Log',
    'rfi-log': 'RFI Log',
    'submittal-log': 'Submittal Log',
    'procurement-log': 'Procurement Log',
    'cost-management': 'Cost Management',
    'change-management-log': 'Change Management Log',
    'utilities': 'Utilities',
    'io-buffer-generation': 'IO Buffer Generation',
    'integration-configuration': 'Configuration',
    'plc-platforms': 'PLC Platforms',
    'plc-tag-xref': 'Tag XRef',
    'udt-comment-generator': 'UDT Comment Generator',
    'scada-tag-generation': 'SCADA Tag Generation',
    'simulation-tag-generation': 'Simulation Tag Generation',
    'administration-dashboard': 'Administration Dashboard',
    'admin/dashboard': 'Security Dashboard',
    'admin/security': 'Security Overview',
    'admin/users': 'Admin Users',
    'admin/roles': 'Permission Defaults',
    'admin/permissions': 'Permissions List',
    'admin/databases': 'Databases',
    'admin/organizations': 'Organizations',
    'development-dashboard': 'Development Dashboard',
    'task-log': 'Task Log',
    'rev-log': 'Rev Log',
    'dev-plan': 'Dev Plan',
    'field-manager': 'Field Manager',
    'claude-notes': 'PMD Claude Notes',
    'standard-view-config': 'Standard View Composer',
    'icon-browser': 'Icon Browser',
    'import-template': 'Bulk Import',
    'lookup-values': 'Lookup Values',
    'display-settings': 'Display Settings',
    'power-query': 'Power Query',
    'database-sync': 'Data Synchronization',
    'view-synchronizer': 'View Synchronization',
    'schema-synchronizer': 'Schema Synchronization',
    'style-guide': 'Style Guide'
  };
  return pageNames[destination] || destination;
};
